<app-simple-responsive-frame>
    <div class="details image-container">
        <h2>Agrega fotos de tu {{ segmentLabel?.toLowerCase() }}.</h2>
        <p class="description">
            Necesitas subir por lo menos X fotos para publicar tu propiedad. Puedes hacer cambios más adelante.
            Usa formato JPEG o PNG. Máximo X MB por foto.
        </p>

        <!-- GRID RESPONSIVE -->
        <div class="image-grid">
            <div *ngFor="let category of imageCategories; trackBy: trackByCat" class="image-item">
                <h5 class="category-title">
                    {{ category.label }} <span *ngIf="category.mandatory" class="required">*</span>
                </h5>

                <!-- DROPZONE estilo Figma -->
                <div
                    class="dropzone"
                    [class.disabled]="category.uploading"
                    (click)="fileInput.click()"
                    (dragover)="onDragOver($event)"
                    (drop)="onDrop($event, category, fileInput)">
                    <img class="dz-icon" src="assets/layout/images/icons/icon-image.png" alt="" />
                    <span class="dz-title">Arrastra tus fotos aquí</span>
                    <span class="dz-choose">Seleccionar fotos</span>

                    <!-- Input nativo oculto: el dropzone dispara el click y el (drop) ya está
                         cableado. Reemplaza al overlay p-fileUpload que bloqueaba el arrastrar/soltar. -->
                    <input
                        #fileInput
                        type="file"
                        class="hidden-input"
                        multiple
                        accept="image/jpeg,image/png,video/mp4,video/quicktime"
                        (change)="onSelectValidate({ files: fileInput.files }); onUpload({ files: fileInput.files }, category, fileInput); fileInput.value = ''" />
                </div>

                <!-- Thumbnails -->
                <div class="thumbs" *ngIf="category.images?.length">
                    <div class="thumb" *ngFor="let file of category.images; trackBy: trackByFile">
                        <ng-container [ngSwitch]="file.type">
                            <ng-container *ngSwitchCase="'image'">
                                <img
                                    *ngIf="!file.broken"
                                    [src]="file.previewUrl || file.url"
                                    [alt]="file.name"
                                    (error)="markBroken(file)" />
                                <div *ngIf="file.broken" class="image-fallback">
                                    <i class="pi pi-image"></i>
                                    <span>{{ file.name }}</span>
                                </div>
                            </ng-container>
                            <div *ngSwitchDefault class="video-pill">
                                <i class="pi pi-video"></i> {{ file.name }}
                            </div>
                        </ng-container>

                        <button
                            type="button"
                            class="delete-btn"
                            pButton
                            icon="pi pi-trash"
                            [attr.aria-label]="'Eliminar ' + file.name"
                            (click)="onDeleteImage({ id: file.id }, category)"
                        ></button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Errores -->
    <div class="error-message" *ngIf="showErrorDialog">
        <ul class="text-danger list-unstyled" style="list-style:none;padding:0;margin:5px 0 0">
            <li><p-message severity="error" [text]="dialogCode + ' ' + dialogMessage"></p-message></li>
        </ul>
    </div>

    <app-page-navigation-bar
        [value]="55"
        [type]="'complete'"
        [previousPageURL]="previousUrl"
        [nextPageURL]="nextUrl"
        [flowMode]="currentMode"
        [stepKey]="'pictures'"
        (goNext)="handleNextStep()"
        (goPrevious)="handlePreviousStep()"
        (saveAndExit)="handleSaveAndExit()">
    </app-page-navigation-bar>
</app-simple-responsive-frame>

<p-toast></p-toast>
<p-progressSpinner *ngIf="loading" styleClass="spinner-center"></p-progressSpinner>
